import { setContext } from 'apollo-link-context';

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('authToken');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      ...token && { Authorization: `Bearer ${token}` },
    },
  };
});

export default authLink;



// WEBPACK FOOTER //
// ./src/data/links/authLink.js